import React from "react";
import { useNavigate } from "react-router-dom";
import { linkOpen } from "utils/util";
import CmsPreviewShell from "./CmsPreviewShell";

const formatPrice = (price) => {
  if(!!price === false){
    return
  }else{
    return  price.toLocaleString("ko-KR") + "원"
  }
 }

const FeaturedComponent = ({ title, subtitle, layout, items = [] }) => {
  const navigate = useNavigate();
  const handleClick = (link) => linkOpen(link, navigate);

  return (
    <CmsPreviewShell title={title} subtitle={subtitle}>
      <div className={`cms-featured cms-featured--${layout}`}>
        {items.map((item) => (
          <div key={item.id} className="cms-featured__item" onClick={() => handleClick(item.link)}>
            <div className="cms-featured__image">
              <img src={item.img} alt={item.title} />
              {item.type && <span className={`cms-featured__badge cms-featured__badge--${item.type}`}>
                {item.type === "lesson" ? "강습" : "상품"}
              </span>}
            </div>
            <div className="cms-featured__body">
              <h5 className="cms-featured__name">{item.title}</h5>
              <p className="cms-featured__desc">{item.description}</p>
              <div className="cms-featured__price">
                {item.discount ? (
                  <>
                    <span className="cms-featured__discount">{item.discount}%</span>
                    <span className="cms-featured__final">{formatPrice(item.price)}</span>
                  </>
                ) : (
                  <span className="cms-featured__final">{formatPrice(item.price)}</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </CmsPreviewShell>
  );
};

export default FeaturedComponent;
